/**
 * External Imports
 */
import styled from 'styled-components';

/**
 * Nexus Imports
 */
import { NeuIcon, NeuImage } from '@neutron/react';

export const IconDiv = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  margin-right: 0.5rem;
  width: 22px;
`;

// TODO: Not being used currently
export const AvatarDiv = styled.div`
  padding-top: 5px;
`;

export const EmployeeInfoDiv = styled.div`
  display: flex;
  align-items: center;
`;

// TODO: Not being used currently
export const EmployeeAvatar = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
`;

export const ToDoIcon = styled(NeuIcon)`
  font-size: 12px;
  padding-right: 5px;
`;

export const CompleteIcon = styled(NeuIcon)`
  color: #00558c;
  font-size: 1.25rem;
  margin-left: -5px;
`;

export const OverdueImg = styled(NeuImage)``;

export const DeptStartContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  text-align: center;
`;
export const StartDateContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
  padding-right: 2px;
`;
export const NewHireIconContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
`;
